import Repository from "./repository"

const resource = 'report'

export default {
    async getTodayReportBase({ page, take, search, status, skill, fromDate }) {
        page = page === undefined ? 1 : page;
        take = take === undefined ? 10 : take;
        let endpoint = `${resource}/today/summary?page=${page}&take=${take}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        if (status !== undefined && status !== null && status !== '') {
            endpoint += `&status=${status}`;
        }
        if (skill !== undefined && skill !== null && skill !== '') {
            endpoint += `&skill=${skill}`;
        }
        if (fromDate !== undefined && fromDate !== null && fromDate !== '') {
            endpoint += `&fromDate=${fromDate}`;
        }
        let response = await Repository.get(endpoint);
        return response
    },
    async getReportBase({ date, page, take, search }) {
        page = page === undefined ? 1 : page;
        take = take === undefined ? 10 : take;
        let endpoint = `${resource}/summary?page=${page}&take=${take}&date=${date}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        let response = await Repository.get(endpoint);
        return response;
    },
    async downloadReportBase({ date, search }) {
        let endpoint = `${resource}/summary/download?date=${date}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        let response = await Repository.get(endpoint);
        return response;
    },
    async getTodayIntervalReportBase() {
        let endpoint = `${resource}/today/interval`;
        let response = await Repository.get(endpoint);
        return response
    },
    async getIntervalReportBase({ date }) {
        let endpoint = `${resource}/interval?date=${date}`;
        let response = await Repository.get(endpoint);
        return response
    }
}